module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-back-top', {
    attrs: {
      "height": 1,
      "top": 100,
      "right": 10,
      "duration": 1000,
      "callBack": _vm.backTopCallBack
    }
  }, [_c('mu-raised-button', {
    staticClass: "demo-raised-button iconfont icon-dingbu",
    attrs: {
      "primary": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaa42266","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/m-backtop.vue
// module id = 160
// module chunks = 2